/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for perspectiveType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="perspectiveType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="asOfDate"/&gt; &lt;enumeration value="asOfYesterday"/&gt; &lt;enumeration value="asOfMostRecentData"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class PerspectiveType extends Enum{

	enumValue = null;

	static  AS_OF_DATE = PerspectiveType.newLiteral("asOfDate");

	static  AS_OF_YESTERDAY = PerspectiveType.newLiteral("asOfYesterday");

	static  AS_OF_MOST_RECENT_DATA = PerspectiveType.newLiteral("asOfMostRecentData");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < PerspectiveType.values().length); ++i) {
			if (PerspectiveType.values()[i].enumValue == v) {
				return PerspectiveType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("PerspectiveType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/PerspectiveType.js